/**
 * Created by Ning Jiang on 2022-01-13.
 */

import {IdleAnimationController} from "../IdleAnimationController";
import {TimelineLite} from "gsap";
import {MathHelper} from "../../../core/utils/MathHelper";
import {TombstoneRip} from "../../TombstoneRip";
import {TombstoneRipSymbol} from "../../symbol/TombstoneRipSymbol";

export class SymbolIdleController extends IdleAnimationController {

    private _isPlaying:boolean = false;

    private _startDelay:number = 10;
    private _intervalRange:[number, number] = [4, 10];
    private _mainTl:TimelineLite | null;
    private _symbol:TombstoneRipSymbol | null;

    constructor() {
        super();
    }

    public start():void {
        if(this._isPlaying) {
            return;
        }

        this._isPlaying = true;
        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playAnimation(), this._startDelay);
    }

    public stop():void {
        this._isPlaying = false;
        if(this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._mainTl = null;

        // stop the on going symbol.
        if(this._symbol && !this._symbol.destroyed) {
            this._symbol.stopIdle();
        }
        this._symbol = null;
    }

    private playAnimation():void {
        if(!this._isPlaying) {
            return;
        }

        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playSymbolIdleAnimation());
        this._mainTl.add(() => this.playAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }

    private playSymbolIdleAnimation():void {
        const reelId = MathHelper.randomNumberInRange(0, 3);
        if(TombstoneRip.model.parsedGameData?.doReelNudge[reelId]) {
            // just skip if nudge reel.
            return;
        }
        const symId = reelId === 0 ? MathHelper.randomNumberInRange(0, 1) : MathHelper.randomNumberInRange(0, 2);
        const sym = TombstoneRip.reels[reelId].getSymbol(symId);
        if(sym.stackedSymbolName.isStacked) {
            return;
        }
        // Logger.logDev(`playing idle symbol at reel ${reelId}, sym ${symId}`);
        sym.playIdle();
        this._symbol = sym;
    }
}